export function createVisibilityAwarePoller({
    poll,
    intervalMs,
    isVisible = () => document.visibilityState === 'visible',
    setTimer = (callback, delayMs) => window.setTimeout(callback, delayMs),
    clearTimer = timerId => window.clearTimeout(timerId),
    onError = error => console.error('Process polling failed:', error)
}) {
    let timerId = null;
    let stopped = false;
    let inFlight = false;
    let requestController = null;
    let refreshWhenSettled = false;

    function clearScheduledPoll() {
        if (timerId !== null) {
            clearTimer(timerId);
            timerId = null;
        }
    }

    function schedulePoll() {
        clearScheduledPoll();
        if (!stopped && isVisible()) {
            timerId = setTimer(() => void runPoll(), intervalMs);
        }
    }

    async function runPoll() {
        clearScheduledPoll();
        if (stopped || !isVisible()) return;

        if (inFlight) {
            refreshWhenSettled = true;
            return;
        }

        inFlight = true;
        refreshWhenSettled = false;
        requestController = new AbortController();

        try {
            await poll(requestController.signal);
        } catch (error) {
            if (error.name !== 'AbortError') {
                onError(error);
            }
        } finally {
            inFlight = false;
            requestController = null;

            if (stopped) return;
            if (refreshWhenSettled && isVisible()) {
                refreshWhenSettled = false;
                void runPoll();
                return;
            }

            schedulePoll();
        }
    }

    function handleVisibilityChange() {
        clearScheduledPoll();

        if (!isVisible()) {
            requestController?.abort();
            return;
        }

        if (inFlight) {
            refreshWhenSettled = true;
        } else {
            void runPoll();
        }
    }

    function stop() {
        stopped = true;
        clearScheduledPoll();
        requestController?.abort();
    }

    return {
        handleVisibilityChange,
        start: schedulePoll,
        stop
    };
}
